import { CarIcon, LocationPinOutlinedIcon, TrainIcon } from 'assets/icons';

const EventLocation = ({ location }) => {
  const sanitizedLocation = encodeURIComponent(location);

  return (
    <section className="event__section event__location">
      <h2>Location</h2>
      <h3 className="h5 fl ai-c">
        <LocationPinOutlinedIcon width={24} height={24} className="mr-4" />
        Address
      </h3>
      <p className="fs-16 tc-secondary mb-28">{location}</p>
      <h3 className="h5">How to Get There</h3>
      <div className="location__directions-links mb-24">
        <a
          href={`https://www.google.com/maps/dir/?api=1&destination=${sanitizedLocation}&travelmode=driving`}
          className="mr-24"
          target="_blank"
          rel="noreferrer">
          <CarIcon />
          <span className="hide-text">Driving directions</span>
        </a>
        <a
          href={`https://www.google.com/maps/dir/?api=1&destination=${sanitizedLocation}&travelmode=transit`}
          target="_blank"
          rel="noreferrer">
          <TrainIcon />
          <span className="hide-text">Public transport directions</span>
        </a>
      </div>
      <iframe
        title="Event Location"
        className="event__location-map"
        src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyCz3B5c6-orkW25i-rms0nHaXpXFwcgV34&q=${sanitizedLocation}`}
      />
    </section>
  );
};

export default EventLocation;
